<template>
  <div>
    <v-row>
      <v-col class="titulos">
        <div class="dadosCadastrais">
          <ModalDadosCadastrais
            :dadosPayload="dados"
            :disabled="dados && !dados.cnpj"
            ref="dadosCadastraisModal"
            @saved="handleDadosCadastraisSaved"
            @closed="handleDadosCadastraisClosed"
          >
            <template v-slot:title> Dados Cadastrais </template>
          </ModalDadosCadastrais>
        </div>
        <template v-if="municipio && municipio.faixaId">
          <div
            v-if="
              isFullAdmin ||
              (config.gerarEditarProposta && groupsConfig.gerarEditarProposta)
            "
          >
            <v-tooltip bottom>
              <template v-slot:activator="tooltip">
                <div
                  v-bind="tooltip.attrs"
                  v-on="possuiPropostaEmProcessamento && tooltip.on"
                >
                  <v-btn
                    color="primary"
                    class="mr-3"
                    :disabled="possuiPropostaEmProcessamento"
                    @click="startNovaProposta"
                  >
                    Gerar Nova Proposta
                  </v-btn>
                </div>
              </template>
              Não é possível gerar nova proposta, devido à existência de uma
              em processamento.
            </v-tooltip>
            <NovaPropostaMA
              v-if="['MA', 'PE'].includes((uf || '').toUpperCase())"
              ref="novaPropostaMA"
              :hideActivator="true"
              :payload="{ color: 'error' }"
              @onLoad="list()"
              :possuiPropostaEmProcessamento="possuiPropostaEmProcessamento"
              :combos="combos"
              :faixa="faixa"
              :municipio="municipio"
              :solucoesExtras="solucoesExtras"
            >
              <template v-slot:title> Gerar Nova Proposta </template>
            </NovaPropostaMA>
            <NovaPropostaMT
              v-else-if="(uf || '').toUpperCase() == 'MT'"
              ref="novaPropostaMT"
              :hideActivator="true"
              :payload="{ color: 'error' }"
              @onLoad="list()"
              @refreshSolucoesExtras="listSolucoesExtras"
              :possuiPropostaEmProcessamento="possuiPropostaEmProcessamento"
              :combos="combos"
              :faixa="faixa"
              :solucoesExtras="solucoesExtras"
              :municipio="municipio"
              :allSolutions="allSolutions"
            >
              <template v-slot:title> Gerar Nova Proposta </template>
            </NovaPropostaMT>
            <NovaProposta
              v-else
              ref="novaPropostaPadrao"
              :hideActivator="true"
              :payload="{ color: 'error' }"
              @onLoad="list()"
              @refreshSolucoesExtras="listSolucoesExtras"
              :possuiPropostaEmProcessamento="possuiPropostaEmProcessamento"
              :combos="combos"
              :faixa="faixa"
              :municipio="municipio"
              :solucoesExtras="solucoesExtras"
            >
              <template v-slot:title> Gerar Nova Proposta </template>
            </NovaProposta>
          </div>
        </template>
      </v-col>
    </v-row>
    <v-row v-if="(municipio && !municipio.faixaId) || !municipio">
      <v-col>
        É necessário adicionar uma faixa ao município para calcular os valores
        da proposta.
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="propostas"
          class="elevation-1 w-100 proposta"
          hide-default-footer
          disable-pagination
          :expanded.sync="expanded"
          single-expand
          show-expand
          item-key="municipioPropostaId"
        >
          <template v-slot:item.municipioPropostaId="{ item }">
            <div :title="getStatusTooltip(item)">
              {{ getNumeroProposta(item) }}
            </div>
          </template>

          <template v-slot:item.status="{ item }">
            <div :title="getStatusTooltip(item)">
              {{ item.status }}
            </div>
          </template>

          <template v-slot:item.download="{ item }">
            <div :title="getStatusTooltip(item)">
              <div
                style="display: flex; justify-content: center; column-gap: 10px"
              >
                <div class="title-btn mr-2">
                  <v-btn
                    color="primary"
                    @click="downloadProposta(item.municipioPropostaId)"
                  >
                    <span>Baixar Proposta</span>
                  </v-btn>
                </div>
                <template
                  v-if="
                    uf == 'SC' &&
                    (item.status == enumStatusPropostas.aprovado ||
                      item.status == enumStatusPropostas.execucaoIniciada)
                  "
                >
                  <modalAnalisar
                    :payload="{
                      color: 'success',
                      baixarMinuta: true,
                      disabled: dados && !dados.cnpj,
                      ...item,
                      gerente1: { gerente: {} },
                      gerente2: { gerente: {} },
                    }"
                    :config="configValues"
                    :solucoesExtras="solucoesExtras"
                    @baixarMinuta="downloadMinuta(item.municipioPropostaId)"
                  >
                    <template v-slot:title>
                      Baixar minuta do contrato
                    </template>
                  </modalAnalisar>
                </template>
              </div>
            </div>
          </template>

          <template v-slot:item.analyse="{ item }">
            <div :title="getStatusTooltip(item)">
              <div style="display: flex">
                <template
                  v-if="
                    item.status == enumStatusPropostas.emProcessamento &&
                    (isFullAdmin ||
                      (config.podeAnalisarProposta &&
                        groupsConfig.podeAnalisarProposta))
                  "
                >
                  <div class="mr-3">
                    <modalAnalisar
                      :payload="{ color: 'error', ...item, rejeitar: true }"
                      @onLoad="list()"
                      :config="configValues"
                      :solucoesExtras="solucoesExtras"
                    >
                      <template v-slot:title> Rejeitar Proposta </template>
                    </modalAnalisar>
                  </div>

                  <modalAnalisar
                    :payload="{ color: 'success', aceitar: true, ...item }"
                    :faixa="faixa"
                    :combos="combos"
                    @onLoad="list()"
                    :config="configValues"
                    :solucoesExtras="solucoesExtras"
                  >
                    <template v-slot:title> Aprovar Proposta </template>
                  </modalAnalisar>
                </template>
              </div>
              <template
                v-if="item.status == enumStatusPropostas.execucaoIniciada"
              >
                <div>
                  Execução iniciada dia
                  {{ item.dataExecucao | moment("DD/MM/YYYY") }}
                </div>
              </template>
              <template v-else-if="item.status == enumStatusPropostas.editada">
                <div>
                  {{ getStatusTooltip(item) }}
                </div>
              </template>
              <template
                v-if="
                  item.status == enumStatusPropostas.aprovado &&
                  (isFullAdmin ||
                    (config.verBotaoPropostaIniciarExecucao &&
                      groupsConfig.verBotaoPropostaIniciarExecucao))
                "
              >
                <div style="display: flex; column-gap: 10px">
                  <modalAnalisar
                    :payload="{
                      color: 'success',
                      iniciar: true,
                      disabled: dados && !dados.cnpj,

                      ...item,
                    }"
                    @onLoad="list()"
                    :solucoesExtras="solucoesExtras"
                    :config="configValues"
                  >
                    <template v-slot:title> Iniciar Execução </template>
                  </modalAnalisar>
                </div>
              </template>
              <template v-if="item.status == enumStatusPropostas.rejeitado">
                <img src="assets/img/noEvidence.png" style="width: 30px" />
              </template>
            </div>
          </template>

          <template v-slot:item.acoes="{ item }">
            <div :title="getStatusTooltip(item)">
              <div class="revert">
                <modalDelete
                  :payload="item"
                  @onLoad="list()"
                  v-if="
                    isFullAdmin ||
                    (config.podeExcluirProposta &&
                      groupsConfig.podeExcluirProposta) ||
                    (item.status == enumStatusPropostas.emProcessamento &&
                      item.usuarioCriacao == user.usuarioId)
                  "
                >
                  <template v-slot:title> Deletar Proposta </template>
                </modalDelete>
                <template
                  v-if="item.status != enumStatusPropostas.emProcessamento"
                >
                  <v-btn
                    color="primary"
                    class="mr-3"
                    @click="reverter(item)"
                    v-if="
                      isFullAdmin ||
                      (config.reverterProposta &&
                        groupsConfig.reverterProposta) ||
                      (item.status == enumStatusPropostas.emProcessamento &&
                        item.usuarioCriacao == user.usuarioId)
                    "
                  >
                    Reverter
                  </v-btn>
                </template>
                <div
                  v-if="
                    isFullAdmin ||
                    (config.gerarEditarProposta &&
                      groupsConfig.gerarEditarProposta)
                  "
                  :style="{
                    display:
                      item.status == enumStatusPropostas.emProcessamento
                        ? 'block'
                        : 'none',
                  }"
                >
                  <NovaPropostaMA
                    v-if="uf == 'MA' || uf == 'PE'"
                    :payload="{ color: 'error' }"
                    @onLoad="list()"
                    :possuiPropostaEmProcessamento="possuiPropostaEmProcessamento"
                    :combos="combos"
                    :faixa="faixa"
                    :edit="item"
                    :solucoesExtras="solucoesExtras"
                    :municipio="municipio"
                  >
                    <template v-slot:title> Editar Proposta </template>
                  </NovaPropostaMA>
                  <NovaPropostaMT
                    v-else-if="uf == 'MT'"
                    :payload="{ color: 'error' }"
                    @onLoad="list()"
                    :possuiPropostaEmProcessamento="possuiPropostaEmProcessamento"
                    :combos="combos"
                    :faixa="faixa"
                    :solucoesExtras="solucoesExtras"
                    :edit="item"
                    :allSolutions="allSolutions"
                    :municipio="municipio"
                  >
                    <template v-slot:title> Editar Proposta </template>
                  </NovaPropostaMT>
                  <NovaProposta
                    v-else
                    :payload="{ color: 'error' }"
                    @onLoad="list()"
                    :possuiPropostaEmProcessamento="possuiPropostaEmProcessamento"
                    :combos="combos"
                    :faixa="faixa"
                    :edit="item"
                    :solucoesExtras="solucoesExtras"
                    :municipio="municipio"
                  >
                    <template v-slot:title> Editar proposta </template>
                  </NovaProposta>
                </div>
              </div>
            </div>
          </template>

          <template
            v-slot:item.data-table-expand="{ expand, isExpanded, item }"
          >
            <div :title="getStatusTooltip(item)">
              <template
                v-if="item.status == enumStatusPropostas.execucaoIniciada"
              >
                <div style="display: flex; column-gap: 5px">
                  <v-btn
                    color="primary"
                    class="mr-3"
                    @click="
                      itemExpand = !itemExpand;
                      itemExpandParcelas = false;
                      expand(itemExpand);
                    "
                  >
                    Anexos
                    <v-icon v-if="itemExpand">mdi-chevron-up</v-icon>
                    <v-icon v-else>mdi-chevron-down</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="uf == 'MA' || uf == 'PE'"
                    color="primary"
                    class="mr-3"
                    @click="
                      itemExpandParcelas = !itemExpandParcelas;
                      itemExpand = false;

                      expand(itemExpandParcelas);
                    "
                  >
                    Parcelas
                    <v-icon v-if="itemExpandParcelas">mdi-chevron-up</v-icon>
                    <v-icon v-else>mdi-chevron-down</v-icon>
                  </v-btn>
                </div>
              </template>
            </div>
          </template>

          <template slot="no-data">
            <span> Nenhuma proposta retornada </span>
          </template>

          <template v-slot:expanded-item="props">
            <td colspan="6" style="background: #f5f5f5">
              <AnexosList
                v-if="itemExpand"
                :payload="{
                  ...props.item,
                }"
                @reload="list"
                :municipio="municipio"
              ></AnexosList>

              <parcelas
                v-if="itemExpandParcelas"
                :payload="{
                  ...props.item,
                }"
                @reload="list"
                :municipio="municipio"
              ></parcelas>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import CityHeader from "@/modules/city/components/Header";
import modalDelete from "./modalDelete.vue";
import modalAnalisar from "./modalAnalisar.vue";
import NovaProposta from "./novaProposta.vue";
import NovaPropostaMA from "./ma/novaPropostaMA.vue";
import NovaPropostaMT from "./mt/novaPropostaMT.vue";
import moment from "moment";
import ModalDadosCadastrais from "./modalDadosCadastrais";
import {
  propostaApi,
  municipioPropostaDadosApi,
  municipioPropostaComboApi,
  municipioPropostaSolucaoExtraApi,
} from "@/apis";
import { statusPropostasEnum } from "./statusPropostasEnum";
import { cityAPI } from "@/modules/city";
import { faixaApi } from "@/apis";
import AnexosList from "./anexos/AnexosList.vue";
import { configuracoesAPI } from "@/modules/configuracao/API/configuracoesAPI";
import { solutionAPI } from "@/modules/solution";
import parcelas from "./parcelas/parcelas.vue";
export default {
  name: "ListaProposta",

  components: {
    CityHeader,
    modalDelete,
    modalAnalisar,
    NovaProposta,
    ModalDadosCadastrais,
    NovaPropostaMA,
    AnexosList,
    NovaPropostaMT,
    parcelas,
  },
  computed: {
    ...mapGetters(["isFullAdmin", "user"]),
    uf() {
      return this.$store.state.uf;
    },
  },
  mounted() {
    if (
      this.isFullAdmin ||
      (this.config.podeExcluirProposta &&
        this.groupsConfig.podeExcluirProposta) ||
      (this.config.reverterProposta && this.groupsConfig.reverterProposta) ||
      (this.config.gerarEditarProposta && this.groupsConfig.gerarEditarProposta)
    ) {
      this.headers.push({
        text: "Ações",
        value: "acoes",
        align: "center",
      });
    }
    console.log("🚀 ~ mounted ~ this.propostas:", this.propostas);

    if (this.propostas.length == 0) {
      this.list();
      this.loadConfig();
      this.listSolucoes();
    }
  },
  data() {
    return {
      expanded: [],
      itemExpand: false,
      headers: [
        { text: "Número", value: "municipioPropostaId" },
        { text: "Status", value: "status" },

        { text: "Analisar", value: "analyse" },
        { text: "Download", value: "download", align: "center" },
        { text: "", value: "data-table-expand" },
      ],
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      propostas: [],
      municipioId: this.$route.params.id,
      enumStatusPropostas: statusPropostasEnum,
      possuiPropostaEmProcessamento: false,
      dados: null,
      combos: [],
      municipio: null,
      faixa: null,
      configValues: null,
      solucoesExtras: [],
      itemExpandParcelas: false,
      allSolutions: [],
      pendingNovaProposta: null,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    getNumeroProposta(item) {
      const exibeNumeroProposta =
        this.config?.exibeNumeroPropostaEmVezMunicipioPropostaId ??
        this.config?.ExibeNumeroPropostaEmVezMunicipioPropostaId;
      if (exibeNumeroProposta) {
        const numeroProposta = (item.numeroProposta || "").toString().trim();
        return numeroProposta ? numeroProposta : "-";
      }
      return item.municipioPropostaId;
    },
    getStatusTooltip(item) {
      if (
        item.status !== this.enumStatusPropostas.rejeitado &&
        item.status !== this.enumStatusPropostas.editada
      ) {
        return null;
      }
      const justificativa = (item.justificativaRecusa || "").trim();
      return justificativa || "Sem justificativa informada.";
    },
    startNovaProposta() {
      if (this.possuiPropostaEmProcessamento) {
        return;
      }
      const tipoProposta = this.getTipoNovaProposta();
      if (
        this.config?.dadosCadastraisMunicipio &&
        this.groupsConfig?.dadosCadastraisMunicipio
      ) {
        this.pendingNovaProposta = tipoProposta;
        if (this.$refs.dadosCadastraisModal) {
          this.$refs.dadosCadastraisModal.open();
        }
        return;
      }
      this.openNovaPropostaModal(tipoProposta);
    },
    getTipoNovaProposta() {
      const uf = (this.uf || "").toUpperCase();
      if (["MA", "PE"].includes(uf)) {
        return "ma";
      }
      if (uf === "MT") {
        return "mt";
      }
      return "padrao";
    },
    handleDadosCadastraisSaved() {
      if (!this.pendingNovaProposta) {
        return;
      }
      this.openNovaPropostaModal(this.pendingNovaProposta);
      this.pendingNovaProposta = null;
    },
    handleDadosCadastraisClosed() {
      this.pendingNovaProposta = null;
    },
    openNovaPropostaModal(tipo) {
      const mapaRef = {
        ma: "novaPropostaMA",
        mt: "novaPropostaMT",
        padrao: "novaPropostaPadrao",
      };
      const refName = mapaRef[tipo];
      if (refName && this.$refs[refName] && this.$refs[refName].open) {
        this.$refs[refName].open();
      }
    },
    loadConfig() {
      configuracoesAPI
        .get()
        .then(({ data }) => {
          this.configValues = data.filter(
            (item) => item.configuracaoId == 11 || item.configuracaoId == 12
          );
        })
        .catch((err) => {
          this.$notification.error("Erro ao achar configurações");
          console.log("Erro nas configurações ", err);
          this.setLoading(false);
        });
    },
    downloadMinuta(propostaId) {
      this.setLoading(true);
      propostaApi
        .downloadMinuta(propostaId)
        .then((data) => {
          //  this.$notification.success("Minuta de contrato gerada com sucesso!");
          this.fazerDownloadRelatorio(
            data.data,
            `Minuta do contrato - ${this.municipio.nome}`
          );

          this.downloadProposta(propostaId);
        })
        .catch((err) => {
          this.$notification.error("Erro ao gerar Minuta de contrato");
          console.log("Erro no delete ", err);
          this.setLoading(false);
        });
    },
    downloadProposta(propostaId) {
      this.setLoading(true);
      propostaApi
        .downloadProposta(propostaId)
        .then((data) => {
          // this.$notification.success("Proposta gerada com sucesso!");
          this.fazerDownloadRelatorio(
            data.data,
            `Proposta - ${this.municipio.nome}`
          );

          this.$emit("onLoad");
        })
        .catch((err) => {
          this.$notification.error("Erro ao gerar Proposta");
          console.log("Erro no delete ", err);
          this.setLoading(false);
        });
    },
    fazerDownloadRelatorio(file, nomeArquivo) {
      var fileURL = window.URL.createObjectURL(new Blob([file]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute(
        "download",
        `${nomeArquivo} - ${moment().format("DD.MM.YYYY.HH.mm")}.pdf`
      );

      document.body.appendChild(fileLink);
      fileLink.click();
      this.setLoading(false);
    },
    list() {
      this.setLoading(true);
      propostaApi
        .getPropostasPorMunicipioId(this.municipioId)
        .then((data) => {
          this.propostas = data.data;
          this.possuiPropostaEmProcessamento = !!this.propostas.find(
            (item) => item.status == statusPropostasEnum.emProcessamento
          );

          this.getDados();
        })
        .catch((err) => {
          this.$notification.error("Erro ao listar Proposta");
          console.log("Erro no delete ", err);
          this.setLoading(false);
        });
    },
    reverter(item) {
      this.setLoading(true);

      item.status = statusPropostasEnum.emProcessamento;
      propostaApi
        .update(item)
        .then(() => {
          this.$notification.success("Proposta revertida com sucesso");
          this.list();
          this.setLoading(false);
        })
        .catch((err) => {
          this.$notification.error("Erro ao reverter Proposta");
          console.log("Erro no delete ", err);
          this.setLoading(false);
        });
    },
    async getDados() {
      this.setLoading(true);
      municipioPropostaDadosApi
        .getDadosPorMunicipioId(this.municipioId)
        .then((resp) => {
          this.dados = (resp.data && resp.data.length && resp.data[0]) || {};
          this.getCombos();
        })
        .catch((err) => {
          this.$notification.error("Erro ao obter os Dados cadastrais");
          console.log("Erro no delete ", err);
          this.setLoading(false);
        });
    },
    async getCombos() {
      this.setLoading(true);
      municipioPropostaComboApi
        .list()
        .then((resp) => {
          this.combos = resp.data;
          this.loadCity();
        })
        .catch((err) => {
          this.$notification.error("Erro ao obter dados dos combos");
          console.log("Erro no getCombos ", err);
          this.setLoading(false);
        });
    },
    loadCity() {
      this.setLoading(true);
      cityAPI
        .get(this.municipioId)
        .then((resp) => {
          this.municipio = resp.data;

          if (this.municipio.faixaId)
            this.loadFaixasByCity(this.municipio.faixaId);

          this.listSolucoesExtras();
        })
        .catch((err) => {
          this.$notification.error("Erro ao obter dados do município");
          console.log("Erro no loadCity ", err);
          this.setLoading(false);
        });
    },
    loadFaixasByCity(faixaId) {
      faixaApi
        .get(faixaId)
        .then((res) => {
          this.faixa = res.data;

          this.setLoading(false);
        })
        .catch((err) => {
          this.$notification.error("Erro ao obter dados da faixa");
          console.log("Erro no loadFaixasByCity ", err);
          this.setLoading(false);
        });
    },
    listSolucoesExtras() {
      this.setLoading(true);
      municipioPropostaSolucaoExtraApi
        .listByMunicipio(this.municipioId)
        .then((resp) => {
          this.solucoesExtras = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter soluções");
        });
    },
    listSolucoes() {
      solutionAPI
        .list()
        .then((resp) => {
          this.allSolutions = resp.data;
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter soluções");
        });
    },
  },
};
</script>
<style lang="scss">
.propostas {
  .titulos {
    display: flex;
    justify-content: space-between;
    .dadosCadastrais {
      margin-left: auto;
    }
  }
  .proposta {
    width: 100%;
    td {
      padding: 0 10px !important;
      span.v-btn__content {
        font-size: 10px;
      }
    }
    th {
      background-color: var(--corPrimaria);
      span {
        color: #fff;
        font-size: 14px;
      }
    }
    tbody {
      tr:nth-child(odd) {
        background-color: #a1c2e014;
      }
    }
  }

  .revert {
    display: flex;
  }
}
</style>
